// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class KRI extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Kairi Relative Index';
        this.Comments = 'Kairi Relative Index';
        this.SetIndicatorLine('KRI', Color.Red, 1, LineStyle.SimpleChart);
        this.SetLevelLine('Zero', 0, Color.Gray, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.KRIPeriod = 13;
        super.InputParameter(new InputParameterInteger('KRIPeriod', 'KRIPeriod', 1, 1, 99999));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'KRI(' + this.KRIPeriod + ')';
    }
    createInternalIndicators() {
        this.ma = this.Indicators.iMA(this.CurrentData, this.KRIPeriod, MAMode.SMA, 0, PriceType.Close);
        return [this.ma];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count <= this.KRIPeriod) {
            return;
        }
        const val = this.ma.GetValue();
        this.SetValue(0, 0, ((this.CurrentData.getPriceByType(PriceType.Close) - val) / val) * 100);
    }
}
